
import { DivisionTypeEnum } from 'src/app/profile/enums/division-type.enum';

import { CheckboxListItem } from '../components/checkbox-list/model/checkbox-list-item.model';

export const APARTMENT_TYPE: CheckboxListItem[] = [
  {
    label: 'Apartamento',
    value: 'Apartamento',
    group: DivisionTypeEnum.Apartment
  },
  {
    label: 'Cobertura',
    value: 'Cobertura',
    group: DivisionTypeEnum.Apartment
  },
  {
    label: 'Duplex',
    value: 'Duplex',
    group: DivisionTypeEnum.Apartment
  },
  {
    label: 'Loft',
    value: 'Loft',
    group: DivisionTypeEnum.Apartment
  },
  {
    label: 'Penthouse',
    value: 'Penthouse',
    group: DivisionTypeEnum.Apartment
  },
  {
    label: 'Studio',
    value: 'Studio',
    group: DivisionTypeEnum.Apartment
  },
  {
    label: 'Garden',
    value: 'Garden',
    group: DivisionTypeEnum.Apartment
  },
  {
    label: 'Triplex',
    value: 'Triplex',
    group: DivisionTypeEnum.Apartment
  },
];

export const HOUSE_TYPE: CheckboxListItem[] = [
  {
    label: 'Casa',
    value: 'Casa',
    group: DivisionTypeEnum.House
  },
  {
    label: 'Casa de Vila',
    value: 'Casa de Vila',
    group: DivisionTypeEnum.House
  },
  {
    label: 'Casa Térrea',
    value: 'Casa Térrea',
    group: DivisionTypeEnum.House
  },
  {
    label: 'Casa Condomínio',
    value: 'Casa Condomínio',
    group: DivisionTypeEnum.House
  },
  {
    label: 'Sobrado',
    value: 'Sobrado',
    group: DivisionTypeEnum.House
  },
  {
    label: 'Villagio',
    value: 'Villagio',
    group: DivisionTypeEnum.House
  },
];

export const FLAT_TYPE: CheckboxListItem[] = [
  {
    label: 'Flat',
    value: 'Flat',
    group: DivisionTypeEnum.Flat
  }
];

export const SHED_TYPE: CheckboxListItem[] = [
  {
    label: 'Galpão',
    value: 'Galpão',
    group: DivisionTypeEnum.Warehouse
  },
  {
    label: 'Barracão',
    value: 'Barracão',
    group: DivisionTypeEnum.Warehouse
  }
];

export const HOTEL_TYPE: CheckboxListItem[] = [
  {
    label: 'Hotel',
    value: 'Hotel',
    group: DivisionTypeEnum.Hotel
  }
];

export const CORPORATE_SLABS_TYPE: CheckboxListItem[] = [
  {
    label: 'Lajes corporativas',
    value: 'Lajes corporativas',
    group: DivisionTypeEnum.Slab
  }
];

export const ALLOTMENT_TYPE: CheckboxListItem[] = [
  {
    label: 'Loteamento',
    value: 'Loteamento',
    group: DivisionTypeEnum.Allotment
  }
];

export const MALL_TYPE: CheckboxListItem[] = [
  {
    label: 'Loja',
    value: 'Loja',
    group: DivisionTypeEnum.Mall
  },
  {
    label: 'Mall',
    value: 'Mall',
    group: DivisionTypeEnum.Mall
  }
];

export const RURAL_TYPE: CheckboxListItem[] = [
  {
    label: 'Rural',
    value: 'Rural',
    group: DivisionTypeEnum.Rural
  },
  {
    label: 'Chácara',
    value: 'Chácara',
    group: DivisionTypeEnum.Rural
  },
  {
    label: 'Fazenda',
    value: 'Fazenda',
    group: DivisionTypeEnum.Rural
  },
  {
    label: 'Sítio',
    value: 'Sítio',
    group: DivisionTypeEnum.Rural
  },
];

export const HALL_TYPE: CheckboxListItem[] = [
  {
    label: 'Salão Comercial',
    value: 'Salão Comercial',
    group: DivisionTypeEnum.Salon
  }
];

export const ROOM_TYPE: CheckboxListItem[] = [
  {
    label: 'Salas Comerciais',
    value: 'Salas comerciais',
    group: DivisionTypeEnum.Office
  },
  {
    label: 'Prédio inteiro',
    value: 'Prédio inteiro',
    group: DivisionTypeEnum.Office
  }
];

export const TERRAIN_TYPE: CheckboxListItem[] = [
  {
    label: 'Terreno',
    value: 'Terreno',
    group: DivisionTypeEnum.Land
  }
];

export const PARKING_TYPE: CheckboxListItem[] = [
  {
    label: 'Vaga de garagem',
    value: 'Vaga de garagem',
    group: DivisionTypeEnum.ParkingLot
  }
];

export const DIVISION_TYPE_UNITS = [
  ...APARTMENT_TYPE,
  ...HOUSE_TYPE,
  ...FLAT_TYPE,
  ...SHED_TYPE,
  ...HOTEL_TYPE,
  ...CORPORATE_SLABS_TYPE,
  ...ALLOTMENT_TYPE,
  ...MALL_TYPE,
  ...RURAL_TYPE,
  ...HALL_TYPE,
  ...ROOM_TYPE,
  ...TERRAIN_TYPE
]
